<template>
  <v-card
    no-gutter
    style="width: 100% !important; height: 55% !important;"
    class="align-center justify-center text-center"
  >
    <v-card-title class="headline mb-2">
      {{ $t("log.activeUsersTable.title") }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="activeUsers"
      :loading="loading"
      hide-default-footer
      class="logtable"
      :search="search"
      disable-pagination
    >
      <template v-slot:item.status v-if="activeUsers.length > 0">
        <v-icon fab color="green">mdi-account</v-icon>
      </template>
      <template v-slot:item.createdAt="{ item }">{{
        humanDate(item.createdAt)
      }}</template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { format } from "date-fns";
import CsharpEnum from "@/_helpers/CsharpEnum";

export default {
  name: "LogTable",

  props: {
    module: Object
  },

  methods: {
    ...mapActions("logs", { getActiveUsers: "activeUsers" }),

    humanDate(date) {
      return date !== undefined
        ? format(new Date(date), "dd MMM - HH:mm")
        : "N/A";
    },

    GetTypeString(type) {
      if (CsharpEnum.LogType[type] !== undefined)
        return CsharpEnum.LogType[type].label;

      return "N/A";
    },

    GetTypeColor(type) {
      if (CsharpEnum.LogType[type] !== undefined)
        return CsharpEnum.LogType[type].color;

      return "N/A";
    },

    async updateLog() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      await this.getActiveUsers();
      var self = this;
      if (!this.noTimeout) {
        this.timer = setTimeout(function() {
          self.updateLog();
        }, 83000);
      }
    }
  },

  computed: {
    ...mapState("logs", ["activeUsers"])
  },

  data() {
    return {
      headers: [
        { text: this.$t("log.fields.status"), value: "status" },
        { text: this.$t("log.fields.user"), value: "user.email" },
        { text: this.$t("log.fields.lastAction"), value: "message" },
        { text: this.$t("log.fields.lastSeen"), value: "createdAt" }
      ],
      loading: true,
      search: null,
      timer: null,
      noTimeout: false
    };
  },

  async mounted() {
    await this.updateLog();

    this.loading = false;
  },

  beforeDestroy() {
    this.noTimeout = true;
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
.logtable {
  overflow-y: scroll;
}
</style>
